"use strict";
/* globals module */
/**
 * @module articleSubscriptionsRoute
 * @description Baasic Article Subscriptions Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Article Subscriptions Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../../common");
var contracts_1 = require("../../../core/contracts");
var __1 = require("../");
var ArticleInstanceSubscriptionsRoute = /** @class */ (function (_super) {
    tslib_1.__extends(ArticleInstanceSubscriptionsRoute, _super);
    function ArticleInstanceSubscriptionsRoute(articleSubscriptionsCommentReportedRoute, articleSubscriptionsArticleRoute, articleSubscriptionsCommentRequiresModerationRoute, appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.articleSubscriptionsCommentReportedRoute = articleSubscriptionsCommentReportedRoute;
        _this.articleSubscriptionsArticleRoute = articleSubscriptionsArticleRoute;
        _this.articleSubscriptionsCommentRequiresModerationRoute = articleSubscriptionsCommentRequiresModerationRoute;
        _this.appOptions = appOptions;
        return _this;
    }
    Object.defineProperty(ArticleInstanceSubscriptionsRoute.prototype, "commentReported", {
        get: function () {
            return this.articleSubscriptionsCommentReportedRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ArticleInstanceSubscriptionsRoute.prototype, "article", {
        get: function () {
            return this.articleSubscriptionsArticleRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ArticleInstanceSubscriptionsRoute.prototype, "commentRequiresModeration", {
        get: function () {
            return this.articleSubscriptionsCommentRequiresModerationRoute;
        },
        enumerable: true,
        configurable: true
    });
    var _a, _b, _c, _d;
    ArticleInstanceSubscriptionsRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.ArticleSubscriptionsCommentReportedRoute)),
        tslib_1.__param(1, inversify_1.inject(__1.TYPES.ArticleSubscriptionsArticleRoute)),
        tslib_1.__param(2, inversify_1.inject(__1.TYPES.ArticleSubscriptionsCommentRequiresModerationRoute)),
        tslib_1.__param(3, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.ArticleSubscriptionsCommentReportedRoute !== "undefined" && __1.ArticleSubscriptionsCommentReportedRoute) === "function" ? _a : Object, typeof (_b = typeof __1.ArticleSubscriptionsArticleRoute !== "undefined" && __1.ArticleSubscriptionsArticleRoute) === "function" ? _b : Object, typeof (_c = typeof __1.ArticleSubscriptionsCommentRequiresModerationRoute !== "undefined" && __1.ArticleSubscriptionsCommentRequiresModerationRoute) === "function" ? _c : Object, typeof (_d = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _d : Object])
    ], ArticleInstanceSubscriptionsRoute);
    return ArticleInstanceSubscriptionsRoute;
}(common_1.BaseRoute));
exports.ArticleInstanceSubscriptionsRoute = ArticleInstanceSubscriptionsRoute;
